
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/properties/new",
      function () {
        return require("private-next-pages/properties/new.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/properties/new"])
      });
    }
  